<template>
    <div class="newPage">
        <div class="content">
            <!--相关性分析-->
            <div class="VOCNavBar" v-if="queryParams">
                <div class="title">参数选择</div>
                <div class="navBarItem">
                    <div class="navBarTitle">开始日期</div>
                    <div class="navBarValue">
                        <el-date-picker
                                v-model="queryParams.startTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="navBarItem">
                    <div class="navBarTitle">结束日期</div>
                    <div class="navBarValue">
                        <el-date-picker
                                v-model="queryParams.endTime"
                                size="mini"
                                type="datetime"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="选择日期时间">
                        </el-date-picker>
                    </div>
                </div>
                <div class="navBarItem">
                    <div class="navBarTitle">数据类型</div>
                    <div class="navBarValue">
                        <el-radio-group v-model="queryParams.type">
                            <el-radio :label="0">原始</el-radio>
                            <el-radio :label="1">审核</el-radio>
                            <el-radio :label="2">全部</el-radio>
                        </el-radio-group>
                    </div>
                </div>

                <div class="navBarItem">
                    <div class="navBarTitle">是否应用配置</div>
                    <div class="navBarValue">
                        <el-radio-group v-model="isSel">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                            <!--<el-radio :label="2">全部</el-radio>-->
                        </el-radio-group>
                    </div>
                </div>

                <div class="navBarItem">
                    <div class="navBarTitle">X轴</div>
                    <div class="navBarValue">
                        <el-select
                                v-model="ele1"
                                size="mini"
                                filterable
                                remote
                                reserve-keyword
                                placeholder="请输入关键词"
                                :remote-method="remoteMethod"
                        >
                            <el-option
                                    v-for="item in queryList"
                                    :key="item.mname"
                                    :label="item.name"
                                    :value="item.mname">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="navBarItem">
                    <div class="navBarTitle">Y轴</div>
                    <div class="navBarValue">
                        <el-select
                                v-model="ele2"
                                filterable
                                remote
                                size="mini"
                                reserve-keyword
                                placeholder="请输入关键词"
                                :remote-method="remoteMethod2"
                        >
                            <el-option
                                    v-for="item in queryList2"
                                    :key="item.mname"
                                    :label="item.name"
                                    :value="item.mname">
                            </el-option>
                        </el-select>
                    </div>
                </div>

                <div class="title">选择站点</div>
                <div class="statisticBox">
                    <el-checkbox-group v-model="queryParams.stations">
                        <div v-for="(item,index) in addressList" :key="index">
                            <el-checkbox :label='item'>{{item}}</el-checkbox>
                        </div>
                    </el-checkbox-group>

                </div>
                <div class="btnBox">
                    <el-button type="primary" icon="el-icon-search" size="mini" @click="getList">查询</el-button>
                </div>
            </div>
            <div class="showContentBox">
                <breadcrumb></breadcrumb>
                <div class="showContent">
                    <div class="echartBox" id="echarts1" ref="echarts1"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Echarts from "echarts"
    import ecStat from "echarts-stat"
    import url from "../../../utils/UrlApi"
    import Breadcrumb from "../../../components/breadcrumb";

    var ScatterOption = {
        option: {
            title: {
                text: '',
                subtext: '',
                left: 'center',
                align: 'right',
                textStyle: {
                    fontSize: 14,

                },

            },
            toolbox: {
                //orient: 'vertical',
                left: 'right',
                top: 'center',
                feature: {
                    dataView: {
                        show: true, readOnly: false, optionToContent: function (opt) {
                            console.log(opt.xAxis[0].data);
                            console.log(opt.series);
                        }
                    },
                    //magicType: { show: true, type: ['line', 'bar'] },
                    restore: {show: true},
                    saveAsImage: {show: true}
                },
                top: 25,
            },
            tooltip: {
                trigger: 'axis',
                axisPointer: {
                    type: 'cross'
                }
            },
            xAxis: {
                type: 'value',
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: ['#000000'],
                        width: 1,
                        type: 'solid'
                    }
                },
                name: "",
                nameLocation: 'middle',
                nameGap: 35,
            },
            yAxis: {
                type: 'value',
                //min: 1.5,
                splitLine: {
                    show: true,
                    lineStyle: {
                        color: ['#000000'],
                        width: 1,
                        type: 'solid'
                    }
                },
                name: "",
                nameLocation: 'middle',
                nameGap: 35,
                min: 0
            },
            series: [{
                symbolSize: 8,
                name: '',
                type: 'scatter',
                itemStyle: {
                    normal: {
                        color: '#005344',
                        borderColor: "#000",
                        borderWidth: 1,
                    }

                },
                data: []
            }, {
                name: 'line',
                type: 'line',
                showSymbol: false,
                data: [],
                z: 3,
                markPoint: {
                    itemStyle: {
                        normal: {
                            color: 'transparent'
                        }
                    },
                    label: {
                        normal: {
                            show: true,
                            position: 'left',
                            formatter: "",
                            textStyle: {
                                color: '#333',
                                fontSize: 14
                            }
                        }
                    },
                    data: [{
                        coord: []
                    }]
                }
            }]
        },
        Create: function (title, x, y, seriesData, dataname, linename) {
            var myRegression = ecStat.regression('linear', seriesData);

            // console.warn('myRegression--------------------')
            // console.log(seriesData)
            // console.log(myRegression)
            myRegression.points.sort(function (a, b) {
                return a[0] - b[0];
            });

            //利用json的序列化和反序列化实现深拷贝
            var newOption = JSON.parse(JSON.stringify(this.option));
            //标题
            newOption.title.text = title;
            newOption.series[0].data = seriesData;
            newOption.series[0].name = dataname;
            newOption.series[1].data = myRegression.points;
            // newOption.title.subtext = myRegression.expression + "(R²=" + myRegression.r2 + ")";
            newOption.title.subtext = myRegression.expression;

            newOption.series[1].markPoint.data[0].coord = myRegression.points[myRegression.points.length - 1];
            newOption.series[1].name = linename;
            newOption.xAxis.name = x;
            newOption.yAxis.name = y;
            return newOption;
        },
        lineCreate: function (newOption, lineseriesdata, linecolor) {
            //利用json的序列化和反序列化实现深拷贝
            for (var i = 0; i < lineseriesdata.length; i++) {
                newOption.series.push({
                    data: lineseriesdata[i],
                    type: 'line',
                    symbol: 'none',
                    lineStyle: {
                        color: linecolor[i],
                        //width: 4,
                        type: 'dashed'
                        //normal: {
                        //    lineStyle: {

                        //    }
                        //}
                    }
                })
            }
            return newOption;
        },
        VisualMapCreate: function (title, seriesData, xAxis, yAxis, color, linedata) {
            var myRegression = ecStat.regression('linear', linedata);

            myRegression.points.sort(function (a, b) {
                return a[0] - b[0];
            });

            var visualMap = {
                min: 0,
                max: 100,
                dimension: 2,
                orient: 'vertical',
                right: 5,
                top: 'center',
                text: ['RH%'],
                calculable: true,
                hoverLink: true,
                inRange: {
                    color: color,
                },
                splitNumber: 10
            };
            var newOption = JSON.parse(JSON.stringify(this.option));
            newOption.title.text = title;
            newOption.series[0].data = seriesData;
            newOption.series[1].data = myRegression.points;
            newOption.title.subtext = myRegression.expression + "(R²=" + myRegression.r2 + ")";
            ;
            // newOption.series[1].markPoint.label.normal.formatter = myRegression.expression + "(R²=" + myRegression.r2 + ")";
            newOption.series[1].markPoint.data[0].coord = myRegression.points[myRegression.points.length - 1];
            //newOption.series[1].name = linename;
            newOption.xAxis.name = xAxis;
            newOption.yAxis.name = yAxis;
            newOption.visualMap = visualMap;
            return newOption;
        },
        ChartOnClick: function (newOption, seriesData, index) {
            if (typeof(index) == "undefined") {
                index = 0;
            }
            newOption.series[index].data = seriesData;

            if (newOption.title.subtext != "") {
                var myRegression = ecStat.regression('linear', seriesData);
                myRegression.points.sort(function (a, b) {
                    return a[0] - b[0];
                });
                newOption.series[1].data = myRegression.points;
                newOption.title.subtext = myRegression.expression + "(R²=" + myRegression.r2 + ")";
                newOption.series[1].markPoint.data[0].coord = myRegression.points[myRegression.points.length - 1];
            }

            return newOption;
        },


    }


    function params(obj) {
        let result = '';
        let item;
        for (item in obj) {
            if (obj[item] && String(obj[item])) {
                result += `&${item}=${obj[item]}`;
            }
        }
        if (result) {
            result = '?' + result.slice(1);
        }
        return result;
    }

    export default {
        name: "Chartrelevance",
        components: {Breadcrumb},
        data() {
            return {
                queryParams: {
                    rateType: '1',
                    stations: [],
                    type: 1,
                    page: 1,
                    pageSize: 10,
                },
                isSel: 1,
                ele1: '',
                ele2: '',
                loading: false,
                // queryParams:null,
                timeType: 1,
                addressList: [],
                tableData: null,
                queryList: [],
                queryList2: [],
                navList: [
                    {name: '小时数据完整性'},
                    {name: '日数据完整性'},
                    {name: '月数据完整性'},
                    {name: '年数据完整性'},
                ],
                myChart1: null,
            }
        },
        created() {
            // this.getList()
            this.getParams()
            this.getaddresstree()
            this.getqueryList()
            this.getBorderList()
            // this.getList()
        },
        methods: {
            getParams() {
                let data = {}
                this.$http.get(url.getSelectUse, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        if (res.data.data) {
                            this.queryParams = res.data.data
                            this.queryParams.stations = res.data.data.stations.split(',')
                        }
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getList() {
                // this.initEchart()
                let data = JSON.parse(JSON.stringify(this.queryParams))
                data.stations = this.queryParams.stations.join()
                data.dataVocList = this.dataVocList
                data.pollutants = this.ele1 + '-' + this.ele2

                let newData

                if (this.isSel) {
                    //     导入应用
                    newData = data
                } else {
                    //    不导入应用
                    newData = {
                        startTime: data.startTime,
                        endTime: data.endTime,
                        type: data.type,
                        pollutants: data.pollutants,
                        stations: data.stations,
                    }
                }


                this.loading = true
                this.$http.post(url.vocDataRelatedAnalysisSelect, newData).then(res => {
                    if (res.data.code === '200') {
                        this.loading = false
                        this.tableData = res.data.data
                        this.initEchart()
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            //  获取 站点数据
            getaddresstree() {
                let data = {}
                this.$http.get(url.vocDataAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.addressList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            getqueryList() {
                let data = {}
                this.$http.get(url.vocDatamapping, data).then(res => {
                    if (res.data.code === '200') {
                        this.queryList = res.data.data
                        this.queryList2 = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },


            // 获取 污染物 数据
            getBorderList() {

                let data = {}
                this.$http.get(url.consistencyAnalysisBorderInfo, data).then(res => {
                    if (res.data.code === '200') {
                        this.dataVocList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            //  导出
            excelExport() {
                let data = JSON.parse(JSON.stringify(this.queryParams))
                data.token = localStorage.getItem('token')
                data.stations = this.queryParams.stations.join()
                data.timeType = this.timeType
                let allUrl = url.completenessExcel + params(data)
                window.open(allUrl, '_blank')
            },
            timeTypeChange(index) {
                // console.log(index)
                this.timeType = index
                this.getList()
            },


            initEchart() {

                let res = this.tableData

                var optionObj = ScatterOption.Create(res.xName + " / " + res.yName + "相关性分析图", res.xName + '(ppbV)', res.yName + '(ppbV)', JSON.parse(JSON.stringify(res.data)), "", "");

                let echart = null
                if (!this.myChart1) {
                    this.myChart1 = Echarts.init(document.getElementById('echarts1'));
                }
                echart = this.myChart1

                console.log(optionObj)

                echart.setOption(optionObj)


                // CurPageObj.initdata("VOCCharts1", eval(datas1), "乙炔", "苯", '(ppbV)', '(ppbV)');


                // var optionObj = ScatterOption.Create(Obj.xName + " / " + Obj.yName + "相关性分析图", Obj.xName + '(ppbV)', Obj.yName + '(ppbV)', Obj.data, "", "");
                // if (!this.myChart) {
                //     this.myChart1 = Echarts.init(document.getElementById('echarts'));
                // }
                //
                // console.log(optionObj)
                //
                // this.myChart.setOption(optionObj)

            },

            Calculatedata(rangeX, rangeY, data) {
                var lineseriesdata = [];
                for (var i = 0; i < data.length; i++) {
                    var sublinedata = [];
                    sublinedata.push([rangeX[0], rangeY[0]]);
                    var _data = parseFloat(data[i]);
                    var x = parseFloat(rangeX[1]);
                    var y = parseFloat(rangeY[1]);
                    if (_data * x <= y) {
                        sublinedata.push([x, _data * x]);
                    }
                    else if (y / _data <= x) {
                        sublinedata.push([y / _data, y]);
                    }
                    lineseriesdata.push(sublinedata);
                }
                return lineseriesdata;
            },

            remoteMethod(query) {
                if (query !== '') {
                    let data = {
                        name: query
                    }
                    this.$http.get(url.vocDatamapping, {params: data}).then(res => {
                        if (res.data.code === '200') {
                            this.queryList = res.data.data
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                } else {
                    this.queryList = [];
                }
            },
            remoteMethod2(query) {
                if (query !== '') {
                    let data = {
                        name: query
                    }
                    this.$http.get(url.vocDatamapping, {params: data}).then(res => {
                        if (res.data.code === '200') {
                            this.queryList2 = res.data.data
                        } else {
                            this.$message.error(res.data.message)
                        }
                    })
                } else {
                    this.queryList2 = [];
                }
            },

        }
    }
</script>


<style scoped lang="less">
    @import "../../../assets/vocContent";

    .contentHeader {
        padding: 20px;
        border-bottom: 1px solid #ddd;
        margin-bottom: 10px;
        display: flex;
        justify-content: center;
        div {
            flex: 1;
        }
    }

    .showContent {
        display: flex;
        flex-wrap: wrap;
        overflow: auto;
        .echartBox {
            width: 100%;
            border: 1px solid #ddd;
            height: 700px;
        }
    }

    .showContentBox {
        flex: 1;
        overflow: auto;
    }
</style>